import {startCustomElementSetup} from "./customElementSetup";
import {fireInitEvent} from "./events";

import * as api from './api'
import {debugEvent, setupCommonComponents} from "@webng/react-app-common";
import {EmbedJsErrorBoundary} from "./EmbedJsErrorBoundary";
import {notifyError} from "../analytics/notifyError";
import {setupGlobalErrorHandler} from "../analytics/setupGlobalErrorHandler";
import {tracedFetch} from "../utils/tracedFetch";

function _init() {
  setupGlobalErrorHandler()

  setupCommonComponents({
    ErrorBoundary: EmbedJsErrorBoundary,
    notifyError,
    fetchFn: tracedFetch,
    debugEvent: debugEvent
  })

  fireInitEvent()

  startCustomElementSetup()
}

(window as any).tik4 = api

_init();
